import { render, staticRenderFns } from "./EditDesignation.vue?vue&type=template&id=6e20d988&"
import script from "./EditDesignation.vue?vue&type=script&lang=js&"
export * from "./EditDesignation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports